import { Logger } from "../helpers";
import { API_ENDPOINTS } from "./config/CONSTANTS";

// === DEV TESTING CONFIG ===
const USE_TEST_IP = false;
const TEST_IP = "67.181.183.227"; // California IP for testing

/**
 * Reads the geo token from <meta name="geo-token"> or fallback to window.geoApiToken.
 */
function getGeoToken() {
  return (
    document.querySelector('meta[name="geo-token"]')?.content ||
    window.geoApiToken
  );
}

/**
 * Checks if the user is in California and sets the consent cookie accordingly.
 */
export async function checkGeoAndSetConsentCookie() {
  if (document.cookie.includes("consentData")) {
    Logger.log("✅ Consent already set");
    return;
  }

  const token = getGeoToken();
  if (!token) {
    Logger.warn("geoApiToken/meta token not found. Skipping geo check.");
    return;
  }

  const payload = {
    token,
    ...(USE_TEST_IP && { ip: TEST_IP }) // Only include IP if testing is enabled
  };

  try {
    const res = await fetch(API_ENDPOINTS.GeoLookup, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    Logger.log("Geo API Response:", data);

    if (data?.isCalifornia) {
      const consentData = {
        hasOptedOut: true,
        hasInteracted: false,
        geoOptout: true,
      };
      document.cookie = `consentData=${encodeURIComponent(JSON.stringify(consentData))}; path=/`;
      Logger.log("Consent cookie set for CA user");
    } else {
      Logger.log("🟢 Non-CA user: no opt-out needed");
    }
  } catch (err) {
    Logger.error("Geo consent check failed:", err);
  }
}
